import { STATUS_META } from "@/lib/constants";

export function StatusBadge({ status, testId }) {
  const meta = STATUS_META[status] || STATUS_META.not_started;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center gap-1.5 px-2.5 py-0.5 rounded-full border text-xs font-mono-tag uppercase tracking-wide ${meta.cls}`}
    >
      <span className="h-1.5 w-1.5 rounded-full bg-current" />
      {meta.label}
    </span>
  );
}
